import type { FaireProductEntity } from "../../entity_types/product";

export const p_r4wwg4haak: FaireProductEntity = {
  token: "p_r4wwg4haak",
  type: "product",
  name: "Organic Wild Lettuce Loose Leaf Tea",
  brandToken: "b_bqcgv7uqrr",
  brandName: "Healing Herbals",
  imageUrl:
    "https://cdn.faire.com/fastly/264d0e2654b6dff5114d1dcccd210c5d5f823cfa7eca1c62f3ba3197c4bd4218.jpeg",
  galleryImageUrls: [],
  priceDollars: 31.03,
  description:
    "\nWild Lettuce Loose Leaf Tea | Healing Herbals\n\nExperience the natural benefits of Wild Lettuce with our premium Loose Leaf Tea. Harvested for its calming properties, Wild Lettuce is traditionally used to promote relaxation and support pain relief. Our Wild Lettuce Tea is crafted from the highest quality leaves, ensuring a pure, potent brew for those seeking a natural way to unwind and alleviate discomfort.\n\nKey Benefits:\n\n * Natural aid for relaxation and stress reduction \n * Supports pain relief and improves sleep quality \n * Made from high-quality, organic wild lettuce leaves \nIdeal for individuals exploring herbal remedies to enhance well-being, our Wild Lettuce Loose Leaf Tea balances tradition with modern wellness needs.",
  tags: [],
  msrpDollars: 38.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:56.345Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
